import { Link } from "react-router-dom";
import { extraArtists, lineup } from "@/mocks/festival";

export default function Lineup() {
  return (
    <section id="lineup" className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <div className="reveal mb-10 md:mb-14">
          <span className="text-xs tracking-[0.24em] text-primary-600">LINE-UP</span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-tight text-foreground-950">
            축제를 빛낼 출연진
          </h2>
          <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
            개막 축하공연과 거봉가요제 무대를 함께할 출연진을 소개합니다.
            이틀 내내 이어지는 무대와 거리 공연을 즐겨보세요.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {lineup.map((artist, i) => (
            <article key={artist.name} className={`reveal reveal-delay-${i + 1}`}>
              <div className="w-full aspect-square overflow-hidden rounded-lg bg-background-100">
                <img
                  src={artist.src}
                  alt={artist.alt}
                  width={600}
                  height={600}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <span className="mt-3 block text-[11px] tracking-[0.16em] text-accent-600">{artist.tag}</span>
              <strong className="mt-1 block font-heading text-base md:text-lg text-foreground-950">
                {artist.name}
              </strong>
              <p className="mt-1 text-xs md:text-sm text-foreground-500">{artist.desc}</p>
            </article>
          ))}
        </div>

        <div className="reveal mt-8 flex flex-wrap items-center gap-3 rounded-lg bg-background-100 px-5 py-5 md:px-7">
          <span className="text-sm font-medium text-foreground-900">그 외 출연진</span>
          <div className="flex flex-wrap gap-2">
            {extraArtists.map((name) => (
              <span
                key={name}
                className="rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs text-secondary-900"
              >
                {name}
              </span>
            ))}
          </div>
          <span className="text-xs text-foreground-500">· 출연진은 사정에 따라 변경될 수 있습니다.</span>
        </div>

        <div className="reveal mt-8 flex flex-col md:flex-row md:items-center gap-5 md:gap-8 rounded-lg bg-primary-900 px-6 py-7 md:px-9">
          <div className="flex items-center gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-500 text-white text-2xl">
              <i className="ri-mic-line"></i>
            </span>
            <div>
              <strong className="block font-heading text-lg text-white">거봉가요제에 도전해 보세요</strong>
              <p className="mt-1 text-sm text-background-200">
                예선 · 본선을 거쳐 최고의 무대를 가리는 거봉가요제 참가자를 모집합니다.
              </p>
            </div>
          </div>
          <Link
            to="/song"
            className="md:ml-auto cursor-pointer inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white px-6 py-3 text-sm font-medium text-primary-700 hover:bg-white/90 transition-colors"
          >
            가요제 참가 신청하기
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}